module.exports = __webpack_public_path__ + "static/img/14001033.89e90596.png";